import classNames from 'classnames'

import featureToggles from 'shared/featureToggles'
import Button from 'shared/components/Button'

import FieldsList from './FieldsList'
import NewSurveyTabs from './NewSurveyTabs'

import styles from '../styles.module.scss'

const SurveyModalContent = ({
    activeTab,
    setActiveTab,
    isNextBtnEnabled,
    onChange,
    formData = {},
    setShowError,
    createSurveyDateError,
    isToggled,
    onToggle,
    onChangeHandlerTextarea,
    createSurveyPending,
    createNewSurveyError,
    createNewSurveyResult,
    onSubmitHandler,
    currentCountrySurveyTabs,
}) => {
    const surveyStepsFlow = currentCountrySurveyTabs.map(step => step.name)
    const translationType = currentCountrySurveyTabs[activeTab].translationType

    const onStepClick = step => setActiveTab(step)

    return (
        <div className={classNames('container', styles.npsContent)}>
            <NewSurveyTabs activeTab={activeTab} surveyStepsFlow={surveyStepsFlow} onStepClick={onStepClick} />
            {activeTab === 0 ? (
                <FieldsList
                    isToggled={isToggled}
                    setIsToggled={onToggle}
                    translationType={translationType}
                    onChange={onChange}
                    prefix="en"
                    formData={formData}
                    setShowError={setShowError}
                    onChangeHandlerTextarea={onChangeHandlerTextarea}
                />
            ) : (
                <FieldsList
                    isToggled={isToggled}
                    setIsToggled={onToggle}
                    translationType={translationType}
                    onChange={onChange}
                    prefix={featureToggles.brNeoPurchaseFlow ? 'pt' : 'fr'}
                    formData={formData}
                    setShowError={setShowError}
                    onChangeHandlerTextarea={onChangeHandlerTextarea}
                />
            )}
            {createSurveyDateError && (
                <div className="text-small text-red text-center mb-4">
                    <T>nps.admin.create.survey.date.error</T>
                </div>
            )}
            {createNewSurveyError && <div className="text-small text-red text-center mb-4">{createNewSurveyError}</div>}
            {createNewSurveyResult && (
                <div className="text-small text-green text-center mb-4">{createNewSurveyResult}</div>
            )}
            <Button
                disabled={!isNextBtnEnabled}
                className={'mx-auto col-12 col-sm-auto'}
                btnStyle={'primary'}
                isLoading={createSurveyPending}
                type={'button'}
                onClick={onSubmitHandler}>
                <T>nps.admin.create.new.survey.next.btn</T>
            </Button>
        </div>
    )
}

export default SurveyModalContent
